var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabsCom"},_vm._l((_vm.tabList),function(v,i){return _c('li',{key:i,class:_vm.activeIndex == i ? 'activeLi' : '',on:{"click":function($event){return _vm.changeActive(i)}}},[_c('p',[_vm._v(_vm._s(v.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }